import React from "react"
import { Heading, Flex, Box } from "@chakra-ui/react"

type Props = {
  children: React.ReactNode
  rightElement?: React.ReactNode
}

const SidePanelHeader = ({ children, rightElement }: Props) => (
  <Flex
    align="center"
    justify="space-between"
    position="sticky"
    top={0}
    zIndex={1}
    py={3}
    px={4}
    bg="gray.100"
  >
    <Heading
      fontWeight="bold"
      fontSize="sm"
      textColor="gray.600"
      textTransform="uppercase"
    >
      {children}
    </Heading>
    {rightElement && (
      <Box>
        {rightElement}
      </Box>
    )}
  </Flex>
)

export default SidePanelHeader
